import React from 'react'
import { getToolLabel } from './toolDisplay'

const activityTextClassName = 'text-sm text-muted-foreground'

type AgentChatToolFallbackProps = {
    toolName: string
}

export const AgentChatToolFallback: React.FC<AgentChatToolFallbackProps> = ({
    toolName,
}) => {
    return <li className={activityTextClassName}>{getToolLabel(toolName)}</li>
}
